import { LocationTypes } from '../../constants';

const decodeLocationTypeObj = (obj) => {
  if (!obj) return null;
  if (obj.portId) {
    return { value: obj.portId, label: obj.label, locationType: LocationTypes.PORT_OF_DEPARTURE };
  }
  return obj;
};

export default decodeLocationTypeObj;
